import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { persistReducer, persistStore } from 'redux-persist';
import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './rootReducer';
import rootSaga from './rootSaga';
var persistConfig = {
    key: 'root',
    storage: storage,
    stateReconciler: autoMergeLevel2,
    blacklist: ['auth', 'layout'],
};
var pReducer = persistReducer(persistConfig, rootReducer);
// Create the Redux Saga middleware
var sagaMiddleware = createSagaMiddleware();
// Create the Redux store
var store = configureStore({
    reducer: pReducer,
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware({
            // serializableCheck: {
            //   ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            // },
            serializableCheck: false,
        }).concat(sagaMiddleware);
    },
});
// Run the root saga
sagaMiddleware.run(rootSaga);
var persistor = persistStore(store);
export { store, persistor };
